import { Injectable, EventEmitter  } from '@angular/core';
import { BehaviorSubject, Observable } from "rxjs";
import { SnackbarService } from '../home/snackbar.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { DataService } from '../data/data.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

export const updateFireBaseTokenUrl     = 'api/Auth';
const BaseUrl = environment.BaseUrl ;

@Injectable({
  providedIn: 'root'
})
export class FireBaseService extends DataService {

  currentMessage = new BehaviorSubject(null);
  fireBaseToken$: string;

  invokeNotificationComponentFunction = new EventEmitter();
  subsVar: Subscription;
  subscriptionLang: Subscription;
  constructor(
    private snackbarService: SnackbarService,
    http:HttpClient,
    
    ) {
      super(updateFireBaseTokenUrl, BaseUrl, http, "FireBaseToken" );

    }

  requestPermission() {
    const messaging = getMessaging();
    getToken(messaging, 
        { vapidKey: environment.firebase.vapidKey}).then(
       (currentToken) => {
         if (currentToken) {
           console.log(currentToken);
           this.fireBaseToken$ = currentToken;
         } else {
           console.log('No registration token available. Request permission to generate one.');
         }
     }).catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
    });
  }
  // Listen to same origin user and Background messages.
  receiveMessage() {
    
    const messaging = getMessaging();
    
    onMessage(messaging, (payload) => {
      
    //  payload.fcmOptions.link='home/orders/order-details/'+payload.data.OrderId
      console.log('Message received. ',payload);
      this.currentMessage.next(payload);
      this.snackbarService.showSnackbarAction(payload?.notification?.title,'Display',payload.data.OrderId)
     //  this.snackbarService.openSnackBar(this.getTitle(payload),'display','')
      this.refreshNotificationsList();

    });
 
    
  }
  
  getTitle(payload){
    let temp:{Language:string,Value:string}[]=JSON.parse(payload?.notification?.title)
    let index= temp.findIndex(val => val.Language=='en')
    return temp[index].Value
  }
  getBody(payload){
    let temp:{Language:string,Value:string}[]=JSON.parse(payload?.notification?.body)
    let index= temp.findIndex(val => val.Language=='en')
    return temp[index].Value
  }
  refreshNotificationsList() {
    this.invokeNotificationComponentFunction.emit();
  }
  updateFireBaseToken(){
    let obj = {firebaseToken:this.fireBaseToken$}
    this.Create(obj,"UpdateFirebaseToken").subscribe({
      next :(res)=>{
        console.log(res);
      },
      error :(err)=>{
        console.log(err);
      }}
    )
  }

}
